// extracted by mini-css-extract-plugin
export var backupIcon = "_sk-1";
export var image = "_sk-0";